module.exports = __webpack_public_path__ + "img/Bodice-Front-B6-Gc-Da-Eb.21feb709.png";